import React from "react";
import { Link } from "react-router-dom";
import { Flex } from "@100mslive/roomkit-react";
import { LogoIcon } from "../../icons";
import AccountActionMenu from "../Common/AccountActionMenu";
import { SESSION_AUTH } from "../../common/auth";
import "./style.scss";

const ProfileContentMenu = ({ orgData }) => {
  return (
    <Link
      to={`/company/${orgData?.orgSlug}`}
      className="events6ix-layout-page-header2-content"
    >
      <div
        className="events6ix-layout-page-header2-content-logo"
        style={{
          backgroundColor: orgData?.orgLogoColor ? orgData?.orgLogoColor : "",
        }}
      >
        {orgData?.orgLogo ? (
          <img src={orgData?.orgLogo} alt="logo" />
        ) : (
          <LogoIcon />
        )}
      </div>
      <div className="events6ix-layout-page-header2-content-info">
        <div className="events6ix-layout-page-header2-content-info-name">
          {orgData?.orgName}
        </div>
      </div>
    </Link>
  );
};

const PageHeader2 = () => {
  const { isUserSession } = SESSION_AUTH();
  return isUserSession ? (
    <Flex
      justify="between"
      align="center"
      className="events6ix-layout-page-header2 events6ix-layout-page-middle"
    >
      <React.Fragment>
        <ProfileContentMenu orgData={isUserSession?.org} />
        <Flex align="center" className="events6ix-layout-page-header2-action">
          <AccountActionMenu />
        </Flex>
      </React.Fragment>
    </Flex>
  ) : null;
};

export default PageHeader2;
